// @flow
import Provider from './Provider';
import Connect from './Connect';

export { default as Provider } from './Provider';
export { default as Connect } from './Connect';

export default {
  Provider,
  Connect,
};



// WEBPACK FOOTER //
// ../react-lib/src/components/utils/Redux/index.js